module.exports = "/assets/6a8e5e9a42103f7e92a83c06cb089ebf.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/supplier/assets/logos/travelcube-icon.png
// module id = 610
// module chunks = 0